interface SecondaryParagraphProps {
  children: string;
  className?: string;
  fontSize?: number;
  fontWheight?: number;
  lineHeight?: number;
}

export const SecondaryParagraph = ({
  children,
  className,
  fontSize = 16,
  fontWheight = 400,
  lineHeight = 24.66,
}: SecondaryParagraphProps) => {
  return (
    <p
      className={`text-[${fontSize}px] leading-[${lineHeight}px] ${className} font-[${fontWheight}]`}
    >
      {children}
    </p>
  );
};
